import { render, staticRenderFns } from "./SupervisorsValidationTab.vue?vue&type=template&id=0b300938&scoped=true&"
import script from "./SupervisorsValidationTab.vue?vue&type=script&lang=js&"
export * from "./SupervisorsValidationTab.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorsValidationTab.vue?vue&type=style&index=0&id=0b300938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b300938",
  null
  
)

export default component.exports